import * as React from 'react'

import { Box, Title } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import i18n from 'modules/core/lib/i18n'

import favouriteDashboards from 'modules/reports/store/collections/favourite_dashboards'

import FavouriteSelector from './_FavouriteSelector'

const Content = ({ children }: React.PropsWithChildren<{}>) => {
  const { access } = useCurrentSession()
  const favourites = favouriteDashboards.filter({
    author_id: access.id,
  })

  const hasFavourites = favourites.length > 0

  return (
    <Box paddingX="s0">
      <Title
        variant="600"
        illustration="user-interaction-review_chart"
        title={i18n.t('custom_reports.dashboards.header.title')}
        description={i18n.t('custom_reports.dashboards.header.description')}
      />
      {hasFavourites && (
        <Box paddingBottom="s64">
          <FavouriteSelector />
        </Box>
      )}
      {children}
    </Box>
  )
}

export default observer(Content)
